
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function CTA() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.3 });
  const handlePurchase = () => {
    window.open('https://deaiwo.base.shop/', '_blank');
  };

  return (
    <section className="pt-32 pb-8 bg-stone-50">
      <div 
        ref={ref}
        className={`max-w-4xl mx-auto px-6 text-center space-y-12 transition-all duration-1000 ${
          isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
        }`}
      >
        <div className="space-y-12">
          {/* Headline */}
          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl leading-relaxed" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400, color: '#705e44' }}>
              愛する家族へ、<br />ひと吹きの上質を。
            </h2>
            <p className="text-base text-stone-600 leading-loose" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400 }}>
              人の肌を整えてきた美容研究を、<br />
              大切なペットへ
            </p>
          </div>

          {/* CTA Button */}
          <div>
            <button
              onClick={handlePurchase}
              className="inline-flex items-center gap-3 px-12 py-5 text-white text-base tracking-wider transition-all duration-300 whitespace-nowrap cursor-pointer hover:opacity-90"
              style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400, backgroundColor: '#705e44' }}
            >
              ご購入はこちら
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
          </div>

          {/* Features */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 pt-8 text-sm text-stone-600" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400 }}>
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-lg"></i>
              <span>公式サイトでのご購入で、安心のサポート体制</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-truck-line text-lg"></i>
              <span>送料無料キャンペーン実施中</span>
            </div>
          </div>
        </div>
      </div>

      {/* Product Details Section */}
      <div className="max-w-6xl mx-auto px-6 mt-32">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Product Details */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h3 className="text-3xl" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 300, color: '#705e44' }}>
                Deaiwo Sarang Spray
              </h3>
              <p className="text-lg" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 300, color: '#705e44' }}>
                Pet Grooming Spray
              </p>
            </div>

            <div className="space-y-6" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 300, color: '#705e44' }}>
              <div className="space-y-2">
                <p className="text-sm text-stone-500">販売名</p>
                <p className="text-base">Deaiwo Sarang Spray</p>
              </div>

              <div className="space-y-2">
                <p className="text-sm text-stone-500">内容量</p>
                <p className="text-base">100ml</p>
              </div>

              <div className="space-y-2">
                <p className="text-sm text-stone-500">成分</p>
                <p className="text-base leading-relaxed">
                  グリセリン、ヒアルロン酸Na、セラミド、グリチルリチン酸2K、<br />
                  グリチルレチン酸ステアリル、帯電防止剤、香料
                </p>
              </div>

              <div className="space-y-2">
                <p className="text-sm text-stone-500">発売元</p>
                <p className="text-base">株式会社Deaiwo</p>
              </div>

              <div className="pt-4">
                <div className="inline-block px-6 py-3 border border-stone-300 text-base" style={{ color: '#705e44' }}>
                  Made in Japan
                </div>
              </div>
            </div>
          </div>

          {/* Product Image */}
          <div className="w-full h-[600px] overflow-hidden">
            <img
              src="https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/4c1c0f3c23a755a7779402b93d00a8f9.png"
              alt="Deaiwo Sarang Spray 商品詳細"
              className="w-full h-full object-contain object-[center_calc(-10mm)]"
              style={{ objectPosition: 'center calc(50% - 10mm)' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}